<template>
    <div>
        <ejs-grid ref='gridUpdatesDetail' :dataSource='complianceUpdatesList' :allowPaging="true" :allowSorting="true" :pageSettings='pageSettings' :locale='locale' :toolbar='toolbar' :searchSettings='searchOptions' :toolbarClick='clickToolbarHandler'>
            <e-columns>
                <e-column field="asunto" :headerText="$t('gridHeaderText.affair')" textAlign="left" :customAttributes="customAttributes"></e-column>
                <e-column field="titulo" :headerText="$t('gridHeaderText.compliance')+'/'+$t('gridHeaderText.obligation')" textAlign="left" :customAttributes="customAttributes"></e-column>
                <e-column field="descripcion" :headerText="$t('gridHeaderText.description')" textAlign="left" :customAttributes="customAttributes" :disableHtmlEncode="false"></e-column>
                <e-column field="created_at" :headerText="$t('gridHeaderText.date')" textAlign="center" :template='createdAtTemplate'></e-column>
            </e-columns>
        </ejs-grid>
    </div>
</template>
<script>
import axios from 'axios';
import { Page, Sort, Toolbar, Search } from "@syncfusion/ej2-vue-grids";

var createdAtTemplateVar = Vue.component("createdAtTemplateVar", {
    template: `<div>{{ data.created_at.substr(0,10) }}</div>`,
    data() {
        return {
            data: {}
        };
    },
    methods: {}
});

export default {
    name: "updates-index",
    props: ["data"],
    provide: {
        grid: [Page, Sort, Toolbar, Search],
    },
    data() {
        return {
            locale: 'es-CO',
            complianceUpdatesList: [],
            pageSettings: { pageSize: 15 },
            toolbar: ['Search', { text: 'Limpiar', tooltipText: '', prefixIcon: 'e-clear', id: 'clear', align: 'Right', cssClass:'btn' }],
            searchOptions: {ignoreAccent: true},
            customAttributes: {class: 'textComplete'},
            createdAtTemplate : function(){
                return {
                    template: createdAtTemplateVar
                };
            }
        }
    },
    methods: {
        initUpdatesDetail: function() {
            axios.post('/auth/processes/getComplianceUpdatesDetail', {
				processId: this.data
			}).then(response => {
                this.complianceUpdatesList = response.data;
			});
        },
        clickToolbarHandler: function(args){
            if (args.item.id === 'clear') {
                this.$refs.gridUpdatesDetail.ej2Instances.searchSettings.key = "";
            }
        }
    },
	created: function() {
    	this.initUpdatesDetail();
  	}
}
</script>
